/**
 * User entity model class
 *
 * This file is part of Minasa
 * (c) Kaden und Partner AG
 */
import BaseModel from './BaseModel';
import BaseCollection from './BaseCollection';
import dayjs from 'dayjs';
import { getI18nInstance as i18n } from '@/i18n';

export class RequestedUser extends BaseModel {
    static LEGAL_TYPE_ORGANIZATION = 'organization';
    static LEGAL_TYPE_PERSON = 'person';

    defaults() {
        return {
            // entity properties
            id: null,
            is_generated: null,
            sent: null,
            user_id: null,
            rejected: null,
            reason: null,
            infomail_tgk: null,
            con_sex: null,
            con_firstname: null,
            con_lastname: null,
            con_street: null,
            con_street_nr: null,
            con_zip: null,
            con_city: null,
            con_address_supplement: null,
            con_po_box: null,
            con_country_id: null,
            con_tel: null,
            con_mobile: null,
            con_email: null,
            con_web: null,
            con_function: null,

            // entity properties / view fields
            legal_type: null,
            title: null,
            description: null,
            sex: null,
            firstname: null,
            lastname: null,
            street: null,
            street_nr: null,
            zip: null,
            city: null,
            address_supplement: null,
            po_box: null,
            country_id: null,
            tel: null,
            email: null,
            mobile: null,
            web: null,
            username: null,
            initials: null,
            created: null,
            organizer_group_id: null,

            // view fields
            category_ids: null,
            organizer_group: null,
            standard_text_tickets: null,
            country: null,
            con_country: null,
            address_id: null,
        };
    }

    mutations() {
        return {
            id: (id: string | number | null) => (Number(id) > 0 ? Number(id) : null),
            created: dayjs,
            is_generated: Boolean,
            sent: Boolean,
            rejected: Boolean,
            infomail_tgk: Boolean,
            user_id: (id: string | number | null) => (Number(id) > 0 ? Number(id) : null),
            con_country_id: (id: string | number | null) => (Number(id) > 0 ? Number(id) : null),
            country_id: (id: string | number | null) => (Number(id) > 0 ? Number(id) : null),
            organizer_group_id: (id: string | number | null) => (Number(id) > 0 ? Number(id) : null),
            address_id: (id: string | number | null) => (Number(id) > 0 ? Number(id) : null),
        };
    }

    get fullname() {
        return [this?.firstname, this?.lastname].filter(Boolean).join(' ');
    }

    get status() {
        if (this.is_generated) {
            return 'generated';
        }
        if (this.rejected) {
            return 'rejected';
        }
        return 'new';
    }

    get statusLabel() {
        switch (this.status) {
            case 'generated':
                return i18n().t('user_already_generated');
            case 'rejected':
                return i18n().t('user_request_rejected', { reason: this.reason });
            default:
                return i18n().t('unreviewed_user_request');
        }
    }

    entityName() {
        return 'RequestedUser';
    }
}

export class RequestedUserCollection extends BaseCollection {
    options() {
        return {
            model: RequestedUser,
        };
    }

    entityName() {
        return 'RequestedUser';
    }
}
